// src/pages/Us.tsx
import React, { useContext, useState, useEffect } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import {Link, useNavigate  } from 'react-router-dom';
import RuntimeValuesProvider, { RuntimeValuesContext } from '../context/RuntimeValuesContext';
import {useTranslation} from 'react-i18next';
import { Helmet } from 'react-helmet';

function Us() {
    const [t, i18n] = useTranslation("global");
    const {runtimeValues, setRuntimeValues} = useContext(RuntimeValuesContext);
    const [title, setTitle] = useState<string>(t("pageTitle.us") + t("seo.compl") + runtimeValues.country + " - wicaglobalgear.com");

    const navigate = useNavigate();

    const handleFilterBrand = (brandName: string) => {
        console.log("brandName", brandName);

        navigate(`/products?brand=${brandName}`);
    }

    useEffect(() => {
        setTitle(t("pageTitle.us") + t("seo.compl") + runtimeValues.country + " - wicaglobalgear.com");
        document.title = title;
    }, [runtimeValues.country]);  

return ( <>
        <Helmet>
            <title>{title}</title> 
        </Helmet>
        <div className="app-container">       
        <Header />
        <div className="app-content">
        <section className="sectionPageContent">
            <div className="plpContainer">
                <div className="plpFilters">
                    <Link to="https://www.red.com/locations-all#dealers" target='_blank' className="header-logo" title="Authorized Dealer">
                        <img className="imgDistributor" alt='Authorized Dealer' src="images/dealer_coin.png"></img>
                    </Link>                         
                </div> 
                <div className="plpProducts">
                    <div className="plpBrandContainer">
                        <header className="plpBrandHeader">
                            <h1>{t("pageTitle.us")} </h1>
                        </header>    
                        <section>
                            <p>{t("us.contentP1")}</p>    
                            <p>{t("us.contentP2")}</p>  
                            <p>{t("us.contentP3")}</p>  
                            <p>{t("us.contentP4")}</p> 
                            <div className="divBasicHorizontal">  
                                <Link to={`/contact`} className="plpButton">{t("nav.item3")}</Link>    
                            </div>                          
                        </section>
                        <section>
                            <div className="divDummy"></div>
                        </section>                         
                    </div> 
                </div> 
            </div>             
                <div className="plpBrandContainerDetail">
                <div className="plpBrand" onClick={() =>handleFilterBrand("red")}>
                    <img src="images/logoRed.png" className="plpBrandImage" alt="RED" />
                    <span className="plpBrandName">RED</span>
                </div>
                <div className="plpBrand" onClick={() =>handleFilterBrand("astera")}>
                    <img src="images/logoAstera.webp" className="plpBrandImage" alt="NMF" />
                    <span className="plpBrandName">ASTERA</span>
                </div>
                <div className="plpBrand" onClick={() =>handleFilterBrand("clay paky")}>
                    <img src="images/logoClayPaky.webp" className="plpBrandImage" alt="NMF" />
                    <span className="plpBrandName">CLAY PAKY</span>
                </div>
                <div className="plpBrand" onClick={() =>handleFilterBrand("minute une")}>
                    <img src="images/logoMinuteUne.webp" className="plpBrandImage" alt="NMF" />
                    <span className="plpBrandName">MINUTE UNE</span>
                </div>
                <div className="plpBrand" onClick={() =>handleFilterBrand("portman lights")}>
                    <img src="images/logoPortman.webp" className="plpBrandImage" alt="NMF" />
                    <span className="plpBrandName">PORTMAN LIGHTS</span>
                </div>
                <div className="plpBrand" onClick={() =>handleFilterBrand("roxx")}>
                    <img src="images/logoRoxx.webp" className="plpBrandImage" alt="NMF" />
                    <span className="plpBrandName">ROXX</span>
                </div>
                <div className="plpBrand" onClick={() =>handleFilterBrand("exalux")}>
                    <img src="images/logoExalux.webp" className="plpBrandImage" alt="NMF" />
                    <span className="plpBrandName">EXALUX</span>
                </div>
                <div className="plpBrand" onClick={() =>handleFilterBrand("magforce magnets")}>
                    <img src="images/logoMagforce.webp" className="plpBrandImage" alt="NMF" />
                    <span className="plpBrandName">MAGFORCE MAGNETS</span>
                </div>
                <div className="plpBrand" onClick={() =>handleFilterBrand("exo skeleton")}>
                    <img src="images/logoExo.webp" className="plpBrandImage" alt="NMF" />
                    <span className="plpBrandName">EXO SKELETON</span>
                </div>        
                <div className="plpBrand" onClick={() =>handleFilterBrand("selby guard")}>
                    <img src="images/logoSelby.webp" className="plpBrandImage" alt="NMF" />
                    <span className="plpBrandName">SELBY GUARD</span>
                </div>                     
            </div>            
        </section>   
        </div>                   
        <Footer />
        </div>        
        </>    );
}

export default Us;    